export const proposerPersonalConstants = [
    {
        name: "Full name",
        key: "fullname",
        value: "",
        show: true,
    },
    {
        name: "Corporate Name",
        key: "corporateName",
        value: "",
        show: true,
    },
    {
        name: "Date of Birth",
        key: "dateOfBirth",
        value: "",
        show: true,
    },
    {
        name: "Gender",
        key: "gender",
        value: "",
        show: true,
    },
    {
        name: "Father's Name",
        key: "fatherName",
        value: "",
        show: true,
    },
    {
        name: "Mother's Name",
        key: "motherName",
        value: "",
        show: true,
    },
    {
        name: "Place Of Birth",
        key: "placeOfBirth",
        value: "",
        show: true,
    },
    {
        name: "Marital Status",
        key: "maritalStatus",
        value: "",
        show: true,
    },
    {
        name: "Maiden Name",
        key: "maidenName",
        value: "",
        show: true,
    },
    {
        name: "Spouse Name",
        key: "spouseName",
        value: "",
        show: true,
    },
    {
        name: "Identity Type",
        key: "identityType",
        value: "",
        show: true,
    },
    {
        name: "Identity Number",
        key: "identityNumber",
        value: "",
        show: true,
    },
    {
        name: "Residential Satus",
        key: "residentialStatus",
        value: "",
        show: true,
    },
    {
        name: "Relationship",
        key: "relationShip",
        value: "",
        show: true,
    },
    {
        name: "PAN",
        key: "panNumber",
        value: "",
        show: true,
    },
    {
        name: "Submit Form 60",
        key: "submitForm60",
        value: "",
        show: true,
    },
    {
        name: "Whether PAN Applied?",
        key: "panApplied",
        value: "",
        show: true,
    },
    {
        name: "Date of Application",
        key: "dateOfApplication",
        value: "",
        show: true,
    },
    {
        name: "Acknowledgement No.",
        key: "acknowledgementNumber",
        value: "",
        show: true,
    },
    {
        name: "Agricultural Income",
        key: "agriculturalIncome",
        value: "",
        show: true,
    },
    {
        name: "Other than agricultural Income",
        key: "otherThanAgriculturalIncome",
        value: "",
        show: true,
    },
    {
        name: "Are you assessed to tax?",
        key: "assessedToTax",
        value: "",
        show: true,
    },
    {
        name: "Ward/Circle/Range where last return of income was field",
        key: "circleOfLastReturnField",
        value: "",
        show: true,
    },
    {
        name: "Reasons for not having PAN/General Index Register number",
        key: "reasonForNotHavingPanOrIGNumber",
        value: "",
        show: true,
    },
    {
        name: "WhatsApp Opt-In",
        key: "whatsappOpt",
        value: "",
        show: true,
    }
    ];

    export const propserEmploymentConstants = [
    {
        name: "Employee Id",
        key: "employeeId",
        value: "",
        show: true,
    },
    {
        name: "Name of Organisation",
        key: "organizationName",
        value: "",
        show: true,
    },
    {
        name: "Job Description",
        key: "jobDescription",
        value: "",
        show: true,
    },
    {
        name: "Other Job Description",
        key: "otherJobDescription",
        value: "",
        show: true,
    },
    {
        name: "Period Of Working",
        key: "periodOfWorkingInYear",
        value: "",
        show: true,
    },
    {
        name: "Other Source of income",
        key: "otherSourceIncome",
        value: "",
        show: true,
    },
    {
        name: "Salaried Type",
        key: "",
        value: "",
        show: true,
    },
    ];

    export const proposerPermanetAddConstants = [
    {
        name: "Adress Line 1",
        key: "addressLine1",
        value: "",
        show: true,
    },
    {
        name: "Address Line 2",
        key: "addressLine2",
        value: "",
        show: true,
    },
    {
        name: "LandMark",
        key: "landmark",
        value: "",
        show: true,
    },
    {
        name: "Pincode",
        key: "pinCode",
        value: "",
        show: true,
    },
    {
        name: "City",
        key: "city",
        value: "",
        show: true,
    },
    {
        name: "State",
        key: "state",
        value: "",
        show: true,
    },
    {
        name: "Alt. Mobile Number",
        key: "alterNateMobNumber",
        value: "",
        show: true,
    },
    {
        name: "Same as Permanent Address",
        key: "sameAsPermanentAddress",
        value: "",
        show: true,
    },
    ];

    export const proposerCorrespondenceAddConstants = [
    {
        name: "Adress Line 1",
        key: "addressLine1",
        value: "",
        show: true,
    },
    {
        name: "Address Line 2",
        key: "addressLine2",
        value: "",
        show: true,
    },
    {
        name: "LandMark",
        key: "landmark",
        value: "",
        show: true,
    },
    {
        name: "Pincode",
        key: "pinCode",
        value: "",
        show: true,
    },
    {
        name: "City",
        key: "city",
        value: "",
        show: true,
    },
    {
        name: "State",
        key: "state",
        value: "",
        show: true,
    },
];
